module.exports = __webpack_public_path__ + "static/img/icon_32_phone.d1b091f5.svg";